import React, { Component } from 'react';
import styles from '../_style/index.less';
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';
import { showRecord } from '@/shared/utils';
const mapStateToProps = (rootState) => ({
    _state: rootState.realtimeMonitoring,
});
class CardInfo extends Component {
    constructor(props) {
        super(props);
        this.handle = (monitorName) => {
            const type = monitorName === 'fousBuyerNum' ? 'focus' : 'browse';
            const { goodsIdStr } = this.props._state.topCarDetails;
            const id = type === 'focus' ? goodsIdStr : this.props.id;
            showRecord({
                id,
                type,
            });
        };
    }
    componentDidMount() {
        dispatch.realtimeMonitoring.getMonitorData('init');
    }
    render() {
        const { monitorData } = this.props._state;
        return (<div className={styles.card_info}>
          <div className={styles.card_title}>车辆监控数据</div>
          <div className={styles.card_item_flex}>
            {monitorData.map((item, index) => {
            const isClicked = item.name === 'browseNum' || item.name === 'fousBuyerNum';
            const { monitorName, monitorCount, name } = item;
            return (<div key={index} className={styles.card_item}>
                    <p>{monitorName}</p>
                    <p onClick={() => {
                isClicked && this.handle(name);
            }} className={isClicked ? styles.card_item_count : ''}>
                      {monitorCount}
                    </p>
                  </div>);
        })}
          </div>
        </div>);
    }
}
export default connect(mapStateToProps)(CardInfo);
